module.exports = __webpack_public_path__ + "static/media/diamond.802753e2.svg";